import { ExportFormatType } from 'Common/Constants/Enumeration/ExportFormatType';

export const FileExportOptions = [
  // { text: 'CSV', value: ExportFormatType.CharacterSeparatedValues },
  { text: 'PDF', value: ExportFormatType.PortableDocFormat },
  { text: 'Excel', value: ExportFormatType.Excel },
];



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/FileExportOptions.js